import React, { Component } from 'react';
import $ from "jquery";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export default class ViewJournalResult extends Component {
  constructor() {
    super();
    this.state = {
      journalData: [],
      isLoading: true,
      noMatchingData: false,

    }
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
  }

  componentDidMount() {
    var thisController = this;

    setTimeout(() => {
      thisController.fetchPatientName();

    }, 300);
  }

  openDeletePopUp = (id) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: "Are you sure to delete this? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteJournalResult(id),
        },
        {
          label: "No",
        },
      ],
    });
  };
  deleteJournalResult = (id) => {
    let journalData = this.state.journalData;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      journalData.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-journal-entry/" + id,

        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            journalData.splice(id, 1);
            // deleteConstructorVariables.notifyDelete();
            deleteApiViewController.refreshData();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        }
      });
    }


  }

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no journal result present. </p>
    </div>
  );

  refreshData = (id) => {
    console.log("Resetting the data");
    this.state.journalData = [];
    this.setState(this.state);
    this.fetchPatientName();
  }

  fetchPatientName() {
    var thisController = this;

    $.ajax({
      url: "/my-jeeva-api/fetch-journal-based-patient",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        journalId: localStorage.getItem("journalId")
      },
      success: function (res) {
        if (res.success == true) {
          // var journalId = localStorage.getItem("journalId");
          var patientJournalData = res.result;
          var sortedData = patientJournalData.sort((a, b) => {
            if (a.answeredBy < b.answeredBy) {
              return -1;
            }
            else if (a.answeredBy > b.answeredBy) { return 1; }
            else { return 0; }
          }
          );
          const uniqueEntries = sortedData.filter(
            (item, index) => index === 0 || item.answeredBy !== patientJournalData[index - 1].answeredBy
          );

          thisController.state.journalData = uniqueEntries;
          console.log("uniqueEntries :" + uniqueEntries);
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.setState(thisController.state);

        }
      },
    });
  }

  showJournalResults = (row, e) => {
    localStorage.setItem("journalId", row.journalId);
    localStorage.setItem("patientId", row.answeredBy);
    localStorage.setItem("journalTitle", row.title);
    localStorage.setItem("patientName", row.answeredByName);
    this.props.history.push( {
    pathname : "/projectmgmt/journal/view-patient-journal-results",
    state : {
      patientName : row.answeredByName
    }
    }
    );
  };

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field].toLowerCase();
    const b = rowB[field].toLowerCase();

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };


  getColumns() {
    var treatmentName = localStorage.getItem("journalGroupName");
    var createdByName = localStorage.getItem("journalCreatedName");
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Patient Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('answeredByName'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.answeredByName}
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Patient Email</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('answeredByEmail'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.answeredByEmail}
          </div>
        ),
      },{
        name: <b style={{ fontSize: "16px" }}>Treatment</b>,
        // sortable: true,
        // sortFunction: this.caseInsensitiveSort('answeredByEmail'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {treatmentName}
          </div>
        ),
      },{
        name: <b style={{ fontSize: "16px" }}>Created by</b>,
        // sortable: true,
        // sortFunction: this.caseInsensitiveSort('answeredByEmail'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {createdByName}
          </div>
        ),
      },
      {
        name: (
          <div Align="center">
            <b style={{ fontSize: "16px" }}>Action</b>
          </div>
        ),
        width: "200px",
        selector: (row) => (
          <div
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "2px",
              paddingTop: "6px",
              width: "100%",
              display: "flex",
            }}
          >

            <button
              style={{
                backgroundColor: "#282a65",
                border: "none",
                color: "white",
                borderRadius: "5px",

              }}
              onClick={(e) => {
                this.showJournalResults(row, e);
              }}
            >
              Journal Entries
            </button>
          </div >
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];
    return columns;
  }

  handleSearch = (event) => {
    var thisController = this;
    var searchTerm = event.target.value;
    thisController.state.searchTerm = searchTerm;
    thisController.state.isLoading = true;
    thisController.state.journalData = [];
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/search-journal-attends",
      method: "GET",
      data: {
        journalId: localStorage.getItem("journalId"),
        searchTerm: searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.journalData = [];
            thisController.setState(thisController.state);
            var sortedData = res.result.sort((a, b) => {
              if (a.answeredBy < b.answeredBy) {
                return -1;
              }
              else if (a.answeredBy > b.answeredBy) { return 1; }
              else { return 0; }
            }
            );
            const uniqueEntries = sortedData.filter(
              (item, index) => index === 0 || item.answeredBy !== res.result[index - 1].answeredBy
            );
  
            thisController.state.journalData = uniqueEntries;
            thisController.state.isLoading = false;
            thisController.state.noMatchingData = false;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
          }
        }
      },
    });

  };

  render() {
    return (
      <div className="main-journal" style={{ margin: "auto", height: "60vh" }}>
        <div style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}>

          <Link to="/projectmgmt/journal">
            <img
              className="img-responsive"
              src="./assets/images/arrow.svg"
              style={{ cursor: "pointer" }}
            />
          </Link>
          <h6
            className="nav-item"
            style={{
              color: "#282a65",
              marginTop: "15px",
              fontSize: "20px",
              marginLeft: "1vh",
              marginTop: "1vh",
              width : "70vw"
            }}
          >
            {localStorage.getItem("journalTitle")} - Entries by Patient
          </h6>
          <input
            type="text"
            style={{
              width: "12vw",
              border: "2px solid #777676",
              borderRadius: "10px",
              padding: "10px",
              height: "0.7vw",
              marginLeft: "2vw"
            }}
            value={this.state.searchTerm}
            onChange={this.handleSearch}
            placeholder="Search ..."
          />
        </div>
        <br />
        {!this.state.noMatchingData && <div style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)", marginRight: "2vw" }}>
          {this.state.isLoading && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>Loading ...</p>
            </div>
          )}
          {!this.state.isLoading && this.state.journalData.length === 0 && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>There are no records for this journal  </p>
            </div>
          )}
          {this.state.journalData.length > 0 && (<DataTable
            columns={this.getColumns()}
            data={this.state.journalData}
            noDataComponent={<this.CustomNoDataComponent />}
          />)}
        </div>}
        <div className='card'>
            {this.state.noMatchingData &&
              <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)", marginRight: "2vw" }}>
                <p>No matching options found ...</p>
              </div>
            }
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewJournalResult.js